export default {
    GetCoursesList: 'api/private/courses',
    AddCourse: 'api/private/courses',
    DeleteCourse: 'api/private/courses',
    UpdateCourse: 'api/private/courses',
    GetCourseById: 'api/public/courses',
    GetMyCourses: 'api/private/my_courses',
    GetCalendarList : 'api/private/courses/calender'
  };
  